<template name="mediaSwiper">
  <div class="media-swiper">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in swiperImg">
          <div class="swiper-zoom-container">
            <img :src="item" preview="1">
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import Vue from 'vue';
import $ from 'jquery';

import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css';

var options= {
  fullscreenEl:false,
  escKey: false,
  clickToCloseNonZoomable: true,
}
Vue.use(preview,options);
export default {
  name: 'mediaSwiper',
  components: {
    preview
  },
  props: {
    swiperImg: Array,
    showVideo: Boolean
  },
  data() {
    return {
      mySwiper: null,
    }
  },
  created() {
    this.createSwiper();
  },
  watch: {
    swiperImg: function() {
      this.mySwiper.destroy();
      this.createSwiper();
    },
    showVideo: function() {
      if (!this.showVideo) {
        this.mySwiper.destroy();
        this.createSwiper();
      }
    }
  },
  methods: {
    createSwiper() {
      setTimeout(() => {
        this.mySwiper = new Swiper('.swiper-container', {
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
          },
        });
      }, 300);
    }
  }
};
</script>
<style lang="scss">
@import "../scss/variables.scss";
.swiper-container {
  width: 100%;
  img {
    width: 100% !important;
    max-height: inherit;
  }
  .swiper-pagination {
    left: auto;
    right: 15px;
    width: auto;
    padding: 3px 15px;
    border-radius: 12px;
    font-size: 12px;
    background: rgba(0,0,0,.2);
    color: #fff;
  }
  .swiper-pagination-current {
    font-weight: bold;
  }
}
</style>
